// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getPeriodSurveys as listPeriodSurveysAPI,
    getPeriodSurvey as getPeriodSurveyAPI,
    addPeriodSurvey as addPeriodSurveyAPI,
    updatePeriodSurvey as updatePeriodSurveyAPI,
    deletePeriodSurvey as deletePeriodSurveyAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { periodSurveysApiResponseError, periodSurveysApiResponseSuccess } from './actions';
import { PeriodSurveysActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getPeriodSurvey({ payload: { id } }) {
    try {
        const response = yield call(getPeriodSurveyAPI, id );
        const periodSurveyItem = response.data.data;
        yield put(periodSurveysApiResponseSuccess(PeriodSurveysActionTypes.GET_PERIOD_SURVEY, periodSurveyItem));
    } catch (error) {
        yield put(periodSurveysApiResponseError(PeriodSurveysActionTypes.GET_PERIOD_SURVEY, error));
    }
}

function* addPeriodSurvey({payload:periodSurvey}){
    try{
        const response = yield call(addPeriodSurveyAPI,{...periodSurvey})
        const periodSurveyItem = response.data
        yield put(periodSurveysApiResponseSuccess(PeriodSurveysActionTypes.ADD_PERIOD_SURVEY,periodSurveyItem))
    } catch(error){
        yield put(periodSurveysApiResponseError(PeriodSurveysActionTypes.ADD_PERIOD_SURVEY,error))
    }
}

function* updatePeriodSurvey({payload:periodSurvey}){
    try{
        const response = yield call(updatePeriodSurveyAPI,{...periodSurvey})
        const periodSurveyItem = response.data.data
        yield put(periodSurveysApiResponseSuccess(PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY,periodSurveyItem))
    }catch(error){
        yield put(periodSurveysApiResponseError(PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY,error))
    }
}
function* deletePeriodSurvey({payload:{id}}){
    try{
        const response = yield call(deletePeriodSurveyAPI,id)
        const periodSurveyItem = response.data.id
        yield put(periodSurveysApiResponseSuccess(PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY,periodSurveyItem))
    }catch(error){
        yield put(periodSurveysApiResponseError(PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY,error))
    }
}

/**
 * List contactos
 */
function* listPeriodSurveys({payload:params}) {
    try {
        const response = yield call(listPeriodSurveysAPI, { ...params });
        const listaPeriodSurveys = response.data.data;
        yield put(periodSurveysApiResponseSuccess(PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS, listaPeriodSurveys));
    } catch (error) {
        yield put(periodSurveysApiResponseError(PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS, error));
    }
}


export function* watchGetPeriodSurvey(): any {
    yield takeEvery(PeriodSurveysActionTypes.GET_PERIOD_SURVEY, getPeriodSurvey);
}

export function* watchListPeriodSurveys(): any {
    yield takeEvery(PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS, listPeriodSurveys);
}

export function* watchAddPeriodSurvey():any{
    yield takeEvery(PeriodSurveysActionTypes.ADD_PERIOD_SURVEY,addPeriodSurvey)
}
export function* watchUpdatePeriodSurvey():any{
    yield takeEvery(PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY,updatePeriodSurvey)
}
export function* watchDeletePeriodSurvey():any{
    yield takeEvery(PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY,deletePeriodSurvey)
}


function* periodSurveysSaga(): any {
    yield all([
        fork(watchGetPeriodSurvey),
        fork(watchListPeriodSurveys),
        fork(watchAddPeriodSurvey),
        fork(watchUpdatePeriodSurvey),
        fork(watchDeletePeriodSurvey),
    ]);
}

export default periodSurveysSaga;
